import { Box } from '@mui/material';

const Background = ({ children }) => {
  return (
    <Box
      sx={{
        background: `
          radial-gradient(circle at 20% 20%, rgba(92, 39, 112, 0.15) 0%, transparent 50%),
          radial-gradient(circle at 80% 80%, rgba(184, 182, 255, 0.2) 0%, transparent 50%),
          linear-gradient(135deg, 
            #5c2770 0%, 
            rgba(110, 73, 140, 1) 25%,
            rgba(147, 119, 183, 1) 50%,
            rgba(174, 155, 215, 1) 75%,
            #b8b6ff 100%
          )
        `,
        backdropFilter: 'blur(10px)',
        height: '100vh',
        width: '100vw',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        overflowX: 'auto',
        position: 'relative',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: `
            radial-gradient(circle at 50% 0%, rgba(255, 255, 255, 0.4) 0%, transparent 60%)
          `,
          pointerEvents: 'none',
        }
      }}
    >
      {children}
    </Box>
  );
};

export default Background;
